<template>
    <ul class="accordion" id="accordion-pconfigurator">
        <slot></slot>
    </ul>
</template>

<script>
import { ref } from 'vue'
export default {
    props: {},
    setup() {

    }
};
</script>

<style lang="scss" scoped>
.accordion {
    list-style: none;
    margin: 0;
    padding: 0;

    &__item:last-child {
        border-bottom: none;
    }
}
</style>
